<template>
  <div class="myhome-header__button">
    <div class="dropdown-content__switch-children-container">
      <div
        class="dropdown-content__switch-children-title dea-heading--medium-m"
        data-test="tooltip__link-switch-account-title"
      >
        Non sei {{ user.firstname }}?<br />
        Vai all'Area Personale di:
      </div>
      <div class="dropdown-content__switch-children-avatar-list">
        <div
          v-for="(child, i) in user.related"
          :key="i"
          class="dropdown-content__switch-children-avatar-single"
          :data-test="`tooltip__link-switch-account--child-${i}`"
          @click="openProfileModal('home', child)"
        >
          <img :src="child.avatar_icon" :alt="child.firstname" />
          <div class="dea-heading--medium-s card-child__firstname">{{ child.firstname }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonSwitchUser",
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    openProfileModal(eventName, user) {
      this.$emit("open-profile-modal", { userId: user.id, firstname: user.firstname, event: eventName });
    },
  },
};
</script>

<style lang="scss">
$avatar-list-width: 100px;

.myhome-header__button {
  .dropdown-content__switch-children-container {
    @include media("<=m") {
      justify-content: space-between;
    }
    width: 100%;
  }

  .dropdown-content__switch-children-avatar-list {
    @include media("<=xs") {
      max-width: $avatar-list-width;
    }
  }
}
</style>
